(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.loginStats', {
                url: '/login-stats',
                templateUrl: 'app/components/loginStats/loginStats.view.html',
                controller: 'LoginStatsController',
                controllerAs: 'vm'
            });
    }
})();
